export default "__VITE_ASSET__ozdeWlYr__"